import React from "react";
import footer from "../../img/wave.png";
import "./Footer.css";

const Footer = () => {
  return (
    <div>
      <div class="divider divback"></div>
      <footer class="footer footer-center p-10   text-base-content rounded">
        <div class="grid lg:grid-flow-col gap-4">
          <a href="#" class="link link-hover">About me</a>
          <a href="#" class="link link-hover">Contact</a>
          <a href="#" class="link link-hover">Services</a>
          <a href="#" class="link link-hover">Projects</a>
        </div>
        <div>
          <div class="grid grid-flow-col gap-4 scale-150">
            <a
              href="https://www.facebook.com/jesandante007"
              className="hover:text-primary"
            >
              <i className="fa fa-facebook-square"></i>
            </a>
            <a
              href="https://www.linkedin.com/in/tanvir-jesan-45b444279"
              className="hover:text-primary"
            >
              <i className="fa fa-linkedin-square"></i>
            </a>
            <a href="#" className="hover:text-primary">
              <i className="fa fa-instagram"></i>
            </a>
            <a
              href="https://github.com/jesandante007"
              className="hover:text-primary"
            >
              <i className="fa fa-github-square"></i>
            </a>
            <a href="#" className="hover:text-primary">
              <i className="fa fa-twitter"></i>
            </a>
          </div>
        </div>
        <div style={{ background: `url(${footer})` }}>
          <p>
            Copyright © 2023 <br /> All right reserved by TAJ
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
